import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';

import { ApmTranslatePipe, AuthFacade, UserPermission } from '@mitsubishi/core';
import { ResourceImageDirective } from '@mitsubishi/shared/ui';

import { FieldType, FieldTypeConfig, FormlyAttributes } from '@ngx-formly/core';

@Component({
  selector: 'apm-input-type',
  templateUrl: './input-type.component.html',
  styleUrls: ['./input-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltip, ApmTranslatePipe, ResourceImageDirective, ReactiveFormsModule, FormlyAttributes],
})
export class InputTypeComponent extends FieldType<FieldTypeConfig> {
  hasDatasheetMoreDetailsPermission = inject(AuthFacade).hasPermission(UserPermission.DatasheetMoreDetails);

  ignoredKeyCodes = ['KeyE'];

  onKeyDown(e: KeyboardEvent) {
    if (this.ignoredKeyCodes.includes(e.code)) {
      e.preventDefault();
    }
  }
}
